import { Component } from '@angular/core';

@Component({
    selector: 'app-main-client-search',
    template: `<router-outlet></router-outlet>`,
})
export class MainComplianceComponent {}
